<!-- 免责声明 -->
<template>
  <div class="disclaimers">
    <div class="recommend-title">
      <div class="item-line line-before"></div>
      <div class="item-dot"></div>
      <div class="item-title">免责声明</div>
      <div class="item-dot"></div>
      <div class="item-line line-after"></div>
    </div>
    <div
      >「betterWE星球」所提供的健康方案仅供参考，用户若患有疾病、长期服药或其他可能会影响健康方案执行的，应当根据自身的健康状况自行评估，必要时需在医生或其他医务人员的指导下进行。「betterWE星球」提供的任何方案，均不能代替医生和其他医务人员的诊断和建议「betterWE星球」也不会提供任何医疗诊断或医疗建议，用户应当理性对待，若用户对其自身健康状况评估错误或对「betterWE星球」的方案判断错误的，应当自行承担相应的后果，「betterWE星球」不对用户作任何类型的担保，也不承担任何责任。</div
    >
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {}
  },
  created() {},
  methods: {}
}
</script>
<style lang="scss" scoped>
.disclaimers {
  font-size: 12px;
  font-family: PingFangSC, PingFang SC;
  color: rgba(0, 0, 0, 0.5);
  line-height: 22px;
  padding: 20px 20px 88px;

  .recommend-title {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    font-family: PingFangSC, PingFang SC;
    color: rgba(0, 0, 0, 0.5);
    line-height: 17px;
    margin-bottom: 20px;

    .item-title {
      margin: 0 12px;
    }

    .item-line {
      width: 40px;
      height: 1px;
      background: linear-gradient(
        90deg,
        rgba(52, 49, 79, 0.15) 0%,
        rgba(52, 49, 79, 0) 100%
      );
    }

    .item-dot {
      width: 4px;
      height: 4px;
      transform: rotate(45deg);
      background: rgba(226, 225, 229, 01);
    }

    .line-before {
      margin-right: -2px;
      transform: rotate(180deg);
    }

    .line-after {
      margin-left: -2px;
    }
  }
}
</style>
